<div class="container pt-4">

  <!-- Sign up -->
  <div class="signup-card shadow-sm mb-5" *ngIf="(authService.isAuthenticated$ | async) === false">
    <div class="signup-card-body text-center">

      <h1>{{'Your international career starts here' | translate}}</h1>

      <p>
        {{'Discover companies actively looking for international talent. Create your free profile and start connecting with employers in the region.' | translate}}
      </p>

      <button type="button" class="btn btn-primary btn-special" (click)="Register()">
        {{'Create your free account' | translate}}
      </button>

    </div>
  </div>

  <!-- Company grid -->
  <div class="companies-section">

    <div class="text-center section-header">
      <h2>{{'Companies looking for international talent' | translate}}</h2>
      <p class="section-subheading">{{'Browse our network of companies ready to connect with you' | translate}}</p>
    </div>

    <div *ngIf="isLoading()" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">{{'Loading...' | translate}}</span>
      </div>
    </div>

    <div class="grid equal-height grid-network" *ngIf="!isLoading()&& companies.length > 0">

      <div class="row">
        <div class="col-6 col-lg-4 col-md-6 col-sm-6" *ngFor="let company of companies">
          <app-company-card [data]="company" [showInternationalBadge]="false"></app-company-card>
        </div>
      </div>

    </div>

    <div class="text-center mt-4 mb-4" *ngIf="!isLoading()">
      <a routerLink="/our-network" class="btn btn-outline-primary">
        {{'View all companies' | translate}}
      </a>
    </div>

  </div>

</div>
